module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-12 float-box-title-extras"
  }, [_c('hr'), _c('form', [_c('div', {
    staticClass: "input-group input-group-sm invisible-addon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtro),
      expression: "filtro"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "id": "camadas-filter",
      "type": "text",
      "placeholder": "Procure por uma camada..."
    },
    domProps: {
      "value": (_vm.filtro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtro = $event.target.value
      }
    }
  }), (!_vm.filtro) ? _c('div', {
    staticClass: "input-group-addon",
    on: {
      "click": function($event) {
        _vm.setFocusFiltro()
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-magnify"
  })]) : _vm._e(), (_vm.filtro) ? _c('div', {
    staticClass: "input-group-addon",
    attrs: {
      "title": "Limpar"
    },
    on: {
      "click": function($event) {
        _vm.limparFiltro()
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-close action-icon"
  })]) : _vm._e()])])]), _c('nav', {
    staticClass: "nav nav-tabs float-box-nav"
  }, [_c('a', {
    staticClass: "col-md-6 nav-link text-center",
    class: {
      active: _vm.tela === _vm.ESTRUTURA
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.setTela(_vm.ESTRUTURA)
      }
    }
  }, [_vm._v("Todas")]), _c('a', {
    staticClass: "col-md-6 nav-link text-center",
    class: {
      active: _vm.tela === _vm.ATIVAS
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.setTela(_vm.ATIVAS)
      }
    }
  }, [_vm._v("Ativas")])]), _c('div', {
    staticClass: "float-box-content content-camadas"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tela === _vm.ESTRUTURA),
      expression: "tela === ESTRUTURA"
    }],
    staticClass: "col-md-12"
  }, [(_vm.estruturaCamadas) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 float-box-content-menu d-flex flex-row-reverse"
  }, [_c('div', {
    staticClass: "action-link",
    on: {
      "click": function($event) {
        _vm.collapseAll()
      }
    }
  }, [_c('span', {
    staticClass: "mdi mdi-arrow-collapse"
  }), _vm._v(" Contrair")]), _c('div', {
    staticClass: "action-link",
    on: {
      "click": function($event) {
        _vm.expandAll()
      }
    }
  }, [_c('span', {
    staticClass: "mdi mdi-arrow-expand"
  }), _vm._v(" Expandir")])])]) : _vm._e(), (_vm.estruturaCamadas) ? _c('camadas-tree', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.filtro),
      expression: "!filtro"
    }],
    ref: "camadasTree",
    attrs: {
      "model": _vm.estruturaCamadas
    }
  }) : _vm._e(), (_vm.estruturaCamadas) ? _c('camadas-tree', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filtro),
      expression: "filtro"
    }],
    attrs: {
      "model": _vm.camadasFiltradas
    }
  }) : _vm._e()], 1), _c('empty-result', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tela === _vm.ESTRUTURA && _vm.filtro && !(_vm.camadasFiltradas && _vm.camadasFiltradas.camadas && _vm.camadasFiltradas.camadas.length)),
      expression: "tela === ESTRUTURA && filtro && !(camadasFiltradas \t\t\t\t\t&& camadasFiltradas.camadas && camadasFiltradas.camadas.length)"
    }],
    staticClass: "full-height",
    attrs: {
      "message": "Nenhuma camada encontrada."
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tela === _vm.ATIVAS),
      expression: "tela === ATIVAS"
    }],
    staticClass: "camadas-ativas"
  }, [(_vm.possuiCamadasUsuario) ? _c('div', {
    staticClass: "float-box-section-title col-md-12"
  }, [_c('label', [_vm._v("Minhas Camadas")]), _c('hr')]) : _vm._e(), (_vm.possuiCamadasUsuario) ? _c('draggable', {
    attrs: {
      "list": _vm.camadasAtivas,
      "options": {
        draggable: '.camada-ativa-wrapper',
        handle: '.col-camada-drag-icon'
      }
    },
    on: {
      "change": _vm.onCamadaMoved
    }
  }, _vm._l((_vm.camadasAtivas), function(c) {
    return (c.camadaUsuario) ? _c('div', {
      staticClass: "camada-ativa-wrapper"
    }, [_c('camada-ativa', {
      attrs: {
        "camada": c
      },
      on: {
        "remove": function($event) {
          _vm.removerCamada(c)
        }
      }
    })], 1) : _vm._e()
  })) : _vm._e(), (_vm.possuiCamadasUsuario) ? _c('div', {
    staticClass: "float-box-section-title col-md-12"
  }, [_c('label', [_vm._v("Camadas SIG")]), _c('hr')]) : _vm._e(), _c('draggable', {
    attrs: {
      "list": _vm.camadasAtivas,
      "options": {
        draggable: '.camada-ativa-wrapper',
        handle: '.col-camada-drag-icon'
      }
    },
    on: {
      "change": _vm.onCamadaMoved
    }
  }, _vm._l((_vm.camadasAtivas), function(c) {
    return (!c.camadaUsuario) ? _c('div', {
      staticClass: "camada-ativa-wrapper"
    }, [_c('camada-ativa', {
      attrs: {
        "camada": c
      },
      on: {
        "remove": function($event) {
          _vm.removerCamada(c)
        }
      }
    })], 1) : _vm._e()
  }))], 1), _c('empty-result', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tela === _vm.ATIVAS && !(_vm.camadasAtivas && _vm.camadasAtivas.length)),
      expression: "tela === ATIVAS && !(camadasAtivas && camadasAtivas.length)"
    }],
    staticClass: "full-height",
    attrs: {
      "message": _vm.filtro ? 'Nenhuma camada encontrada.' : 'Nenhuma camada ativa.'
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cbfc9ac","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/camadas/Camadas.vue
// module id = 475
// module chunks = 1